import React, { useEffect } from 'react';
import { wx } from './';

export default ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    wx.init();
  }, []);
  return children;
};
